import React, { useEffect, useState } from 'react'
import Masonic from 'Components/Masonic/Masonic';
import { Autocomplete, MenuItem, TextField } from '@mui/material';
import { getEjecuciones, cmbSucursal, cmbEstado, cmbCiudad, cmbUsuario } from 'actions/portalClientes';
import { useDispatch } from 'react-redux';


interface FiltersValues {
  name : string | null;
  id: number | null;
}



//ts-ignore
const Ejecuciones = () => {
  const records = 40;
  const dispatch = useDispatch();
  const [data, setData] = useState<any>([])


  const [estado, setEstado] = useState<FiltersValues|null>(null);
  const [ciudad, setCiudad] = useState<FiltersValues|null>(null);
  const [sucursal, setSucursal] = useState<FiltersValues|null>(null);
  const [usuario, setUsuario] = useState<FiltersValues|null>(null);


  const [comboEstado, setComboEstado] = useState<Array<FiltersValues>>([])
  const [comboCiudad, setComboCiudad] = useState<Array<FiltersValues>>([])
  const [comboSucursal, setComboSucursal] = useState<Array<FiltersValues>>([])
  const [comboUsuario, setComboUsuario] = useState<Array<FiltersValues>>([])

  const [page, setPage] = useState(0);
  const [url, setUrl] = useState<string>('')

  const [loading, setLoading] = useState<boolean>(false)


  useEffect(() => {
    if (comboEstado.length === 0 && comboSucursal.length === 0) {
      getAll();
    }
    getData();

  }, [estado, ciudad, sucursal, usuario])

  const getData = async () => {
    let query = `?records=${records}`;
    let flag = false;

    if (estado) { query += `&id_state=${estado.id}` }
    if (ciudad) { query += `&id_city=${ciudad.id}` };
    if (sucursal) { query += `&id_store=${sucursal.id}` }
    if (usuario) { query += `&id_user=${usuario.id}` }

    if(query !== url){
      setLoading(true)
      window.scrollTo(0, 0)
      setPage(1);
      setUrl(query);
      query += `&pagination=${1}`
      flag = true
    }else{
      setPage(page + 1);
      query += `&pagination=${page + 1}`
    }

    let response = await getEjecuciones(query);
    if (response) {
      dispatch({
        type: "SET_TOTALPAGES",
        totalPage: response.totalPages === 0 ? 1 : response.totalPages
      });  
      if(flag) {
        setData(response.data);
      } else{
        setData([...data, ...response.data]);
      }
      
    }else{
      setData([]);
      dispatch({
        type: "SET_TOTALPAGES",
        totalPage: 1
      });
      setPage(1);
    }
    setLoading(false);
  }

  const getAll = async () => {
    let cmbE = await cmbEstado();
    let cmbS = await cmbSucursal();
    let cmbU = await cmbUsuario();

    cmbE !== null && setComboEstado(cmbE);
    cmbS !== null && setComboSucursal(cmbS);
    cmbU !== null && setComboUsuario(cmbU);
  }

  const handleEstado = async (value: any) => {
    if (value) {
      let cmbC = await cmbCiudad(value.id);
      setCiudad(null);
      cmbC !== null ? setComboCiudad(cmbC) : setComboCiudad([]);
    } else {
      setComboCiudad([]);
      setCiudad(null);
    }
    setEstado(value)
  }

  return (
    <div>
      <div style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        alignItems: "center"
      }}>
        <Autocomplete
          options={comboEstado}
          getOptionLabel={(option: any) => option.name}
          onChange={(event: any, value: any) => handleEstado(value)}
          value={estado}
          fullWidth
          id="cmbEstado"
          style={{ margin: "0px 20px" }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Estado"
              variant="standard"
              inputProps={{ ...params.inputProps }}
            />
          )}
        />
        <Autocomplete
          options={comboCiudad}
          getOptionLabel={(option: any) => option.name}
          onChange={(event: any, value: any) => setCiudad(value)}
          value={ciudad}
          fullWidth
          style={{ margin: "0px 20px" }}
          id="cmbCiudad"
          renderInput={(params) => (
            <TextField
              {...params}
              label="Ciudad"
              variant="standard"

              inputProps={{ ...params.inputProps }}
            />
          )}
        />
        <Autocomplete
          options={comboSucursal}
          getOptionLabel={(option: any) => option.name}
          onChange={(event: any, value: any) => setSucursal(value)}
          value={sucursal}
          fullWidth
          style={{ margin: "0px 20px" }}
          id="cmbSucursal"
          renderInput={(params) => (
            <TextField
              {...params}
              label="Sucursal"
              variant="standard"

              inputProps={{ ...params.inputProps }}
            />
          )}
        />
        <Autocomplete
          options={comboUsuario}
          getOptionLabel={(option: any) => option.name}
          onChange={(event: any, value: any) => setUsuario(value)}
          value={usuario}
          fullWidth
          style={{ margin: "0px 20px" }}
          id="cmbUsuario"
          renderInput={(params) => (
            <TextField
              {...params}
              label="Usuario"
              variant="standard"

              inputProps={{ ...params.inputProps }}
            />
          )}
        />
      </div>
      <Masonic items={data} fetchData={getData} page={page} loading={loading} />
    </div>
  );
}






export default Ejecuciones